var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{staticClass:"type-textarea",class:_vm.className,attrs:{"rows":"6","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"blur":_vm.blur,"input":function($event){return _vm.$emit('input', $event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }